import * as Styled from './RadioTab.styled';
import Label from '../Label/Label';
import { RadioTabOptionProps } from './RadioTab.types';

export const RadioTabOption = ({
  text,
  hasError = false,
  disabled = false,
  checked = false,
  value,
  ...rest
}: RadioTabOptionProps) => {
  return (
    <Styled.RadioTabOption
      hasError={hasError}
      disabled={disabled}
      checked={checked}
    >
      <Label htmlFor={value}>
        <Styled.Radio
          type="radio"
          id={value}
          disabled={disabled}
          value={value}
          checked={checked}
          {...rest}
        />
        {text}
      </Label>
    </Styled.RadioTabOption>
  );
};

export default RadioTabOption;
